function FavoritesIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='#aaa'
      version='1.1'
      viewBox='0 0 314.335 314.336'
      xmlSpace='preserve'
    >
      <path d='M302.593 117.321h-80.698c-13.583 0-27.994-10.472-32.191-23.398L164.76 17.179c-4.197-12.925-10.997-12.925-15.198 0l-24.941 76.744c-4.2 12.926-18.612 23.398-32.195 23.398H11.74c-13.583 0-15.688 6.473-4.699 14.462l65.284 47.426c10.989 7.986 16.498 24.932 12.298 37.854l-24.941 76.741c-4.2 12.922 1.309 16.922 12.298 8.93l65.291-47.427c10.988-7.986 28.805-7.986 39.794 0l65.29 47.427c10.988 7.992 16.501 3.98 12.298-8.93l-24.938-76.741c-4.197-12.923 1.31-29.868 12.298-37.854l65.284-47.426c10.988-7.989 8.879-14.462-4.704-14.462z'></path>
    </svg>
  );
}

export default FavoritesIcon;
